module.exports = __webpack_public_path__ + "static/woocommerce_migration_rapyd-5dc7f1dc96ced263737719716539e9cf.mp4";